import { render, staticRenderFns } from "./TeliaLogo.vue?vue&type=template&id=63357a90"
import script from "./TeliaLogo.vue?vue&type=script&lang=js"
export * from "./TeliaLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports